import axios from 'axios';
import router from '../Routes';

export default {
  namespaced: true,
  state: {
    salessummaries: [],
    isFetching: false,
    isReceiving: false,
    hasAlert: false,
    isDone: false,
    errorMessage: '',
    idToDelete: null,
  },
  mutations: {
    DELETED_SALESSUMMARY(state, payload) {
      let indexToDelete = state.salessummaries.findIndex(salessummary => salessummary._id === payload._id);
      let salessummaries = [...state.salessummaries];
      salessummaries.splice(indexToDelete, 1);
      state = Object.assign(state, {
        salessummaries: [...salessummaries],
        isDeleting: false,
        idToDelete: null,
      });
    },
    DELETING_SALESSUMMARY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload._id;
    },
    RECEIVED_SALESSUMMARYS(state, payload) {
      state.salessummaries = payload;
      state.isReceiving = false;
    },
    STOP_RECEIVING(state) {
      state.isReceiving = false;
    },
    RECEIVING_SALESSUMMARYS(state) {
      state.isReceiving = true;
    },
    SALESSUMMARY_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload;
    },
    SALESSUMMARY_SUCCESS(state) {
      state.isFetching = false;
      state.hasAlert= false;
      state.errorMessage = '';
      state.isDone = true;
    },
    SALESSUMMARY_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert= false;
      state.errorMessage = '';
    },
    SALESSUMMARY_DONE(state) {
      state.isFetching= false,
      state.hasAlert = false,
      state.isDone = false,
      state.errorMessage = ''
    }
  },
  actions: {
    async getSalesSummaryByCustomer({dispatch}, payload) {
      try{
        dispatch("receivingSalesSummaries");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/sales/summary/bycustomer';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveSalesSummaries", response.data);
        console.log(response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getSalesSummaryByCustomerSearch({dispatch}, payload) {
      try{
        dispatch("receivingSalesSummaries");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/sales/summary/bycustomer/search';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveSalesSummaries", response.data);
        console.log(response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getSalesSummaryByUser({dispatch}, payload) {
      try{
        dispatch("receivingSalesSummaries");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/sales/summary/byuser';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveSalesSummaries", response.data);
        console.log(response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getSalesSummaryByLocationRequest({dispatch}) {
      try{
        dispatch("receivingSalesSummaries");
        let token = localStorage.getItem('token');
        console.log(token)
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/sales/summary/bylocation';
        let response = await axios({method: "get", url: url, headers: headers});
        dispatch("receiveSalesSummaries", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findSalesSummaryByLocationRequest({dispatch}, payload) {
      try{
        dispatch("receivingSalesSummaries");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/sales/summary/bylocation';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveSalesSummaries", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    deletingSalesSummary({commit}, payload) {
      commit("DELETING_SALESSUMMARY", payload)
    },
    deleteSalesSummary({commit}, payload) {
      commit("DELETED_SALESSUMMARY", payload)
    },
    receiveSalesSummary({dispatch}) {
      dispatch('receiveSalesSummarySuccess');
    },
    receiveSalesSummaries({commit}, payload) {
      commit("RECEIVED_SALESSUMMARYS", payload)
    },
    stopReceiving({commit}, payload) {
      commit("STOP_RECEIVING", payload)
    },
    receivingSalesSummaries({commit}) {
      commit("RECEIVING_SALESSUMMARYS")
    },
    logoutUser() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('usertype');
      document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      axios.defaults.headers.common['Authorization'] = "";
      router.push('/login');
    },
    loginError({commit}, payload) {
      commit('SALESSUMMARY_FAILURE', payload);
    },
    resetSalesSummary({commit}) {
      commit('SALESSUMMARY_DONE');
    },
    receiveSalesSummarySuccess({commit}) {
      commit('SALESSUMMARY_SUCCESS');
      //router.push('/login');
    },
    requestSalesSummary({commit}) {
      commit('SALESSUMMARY_REQUEST');
    },
  }
}
